import { type FC } from "react";

import {
  CardsCarousel,
  CardsCarouselSlide,
} from "~/components/UI/CardsCarousel";
import { TradeOnLinePlatformCard } from "~/feature/event/components/MarketCalculator/components/TradeOnLinePlatformCard";
import type { IAggregatedEvent, IMarket } from "~/types/event";

import { type ITradeOnCard, useTradeOnCards } from "./useTradeOnCards";

interface ITradeOnProps {
  market: IMarket;
  event: IAggregatedEvent;
  singleCard?: boolean;
}

export const TradeOnLine: FC<ITradeOnProps> = ({
  market,
  event,
  singleCard = false,
}) => {
  const cards = useTradeOnCards();

  const renderCard = (card: ITradeOnCard) => (
    <TradeOnLinePlatformCard
      market={card.market}
      event={event}
      calculatedData={card.calculatedData}
      settledElsewhereWarning={card.settledElsewhereWarning}
    />
  );

  if (singleCard) {
    const card = cards.find((item) => item.market.id === market.id);

    return card ? renderCard(card) : null;
  }

  return (
    <CardsCarousel autoplay={false}>
      {cards.map((card) => (
        <CardsCarouselSlide key={card.market.id}>
          {renderCard(card)}
        </CardsCarouselSlide>
      ))}
    </CardsCarousel>
  );
};
